// Kostra košíku při odebrání položky (2026-09-22, zadání Tomáše).
//
// Odebrání jde AJAXem (POST /action/Cart/deleteCartItem/ → GET GetCartContent)
// a Shoptet pak vymění celý `.cart-inner` za čerstvý NATIVNÍ markup. Dokud
// odpověď nedorazí (na dev ~0,7 s), klik na × neměl žádnou odezvu; po ní se na
// ~100 ms ukázal nenastylovaný košík (sloupce Dostupnost/Počet/Cena, červená
// „Do košíku" u souvisejících), než ho checkoutPage.js přestavěl. Druhou půlku
// řeší synchronní přestavba ve `watchCartUpdates` (checkoutPage.js), tenhle
// modul tu první: od kliknutí do odpovědi je košík kostrou.
//
// Mechanika: odebíraná položka se i s navázanými řádky (Hodí se k tomu,
// Související) hned sbalí a zbytek karty i souhrn se vykreslí jako kostra —
// textové uzly dostanou dočasný obal `.bs-skel-t` (šedý pruh přesně v místě
// textu), obrázky, tlačítka a pole šedé tvary, ikony zmizí (_checkout.scss
// §Kostra při odebrání). Geometrie zůstává skutečná, takže nový košík naskočí
// bez skoku. Hotový košík přestaví checkoutPage.js a kostru ukončí; nepřijde-li
// odpověď (chyba sítě, hláška), vrátí `endCartSkeleton` košík do původní
// podoby — nejpozději po TIMEOUT_MS.

const BUSY = 'bs-co-busy';
const WRAP = 'bs-skel-t';
const REMOVING = 'bs-co-removing';
const TIMEOUT_MS = 10000;

// Řádky, které patří k položce a zmizí s ní (renderuje je checkoutPage.js
// a cartCrossSell.js za `tr.bs-co-item`; nativní `tr.related-to-<priceId>`).
const DEPENDENT = ['bs-co-xs', 'bs-co-relrow', 'related'];

// Text, který kostra nechává čitelný: nadpis karty a štítek souhrnu se
// odebráním nemění.
const KEEP = '.bs-co-cart__title, .bs-co-sum__head';
const SKIP_TAGS = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|OPTION|TITLE)$/;

let timer = 0;
let rows = [];

export function cartSkeletonActive() {
  return document.documentElement.classList.contains(BUSY);
}

function dependentRows(row) {
  const out = [row];
  let next = row.nextElementSibling;
  while (next && DEPENDENT.some((c) => next.classList.contains(c))) {
    out.push(next);
    next = next.nextElementSibling;
  }
  return out;
}

function wrapText(root) {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(n) {
      if (!/\S/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
      const p = n.parentElement;
      if (!p || SKIP_TAGS.test(p.tagName) || p.classList.contains(WRAP)) return NodeFilter.FILTER_REJECT;
      if (p.closest('svg') || p.matches(KEEP) || p.closest('.bs-co-cart__title')) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    },
  });
  const texts = [];
  while (walker.nextNode()) texts.push(walker.currentNode);
  for (const t of texts) {
    const span = document.createElement('span');
    span.className = WRAP;
    t.parentNode.insertBefore(span, t);
    span.appendChild(t);
  }
}

/**
 * Košík → kostra. `row` = odebíraná položka (`tr.bs-co-item`), sbalí se
 * s navázanými řádky. Idempotentní (druhý klik během přepočtu nic nedělá).
 */
export function startCartSkeleton(row) {
  const inner = document.querySelector('.cart-inner');
  if (!inner || cartSkeletonActive()) return;
  document.documentElement.classList.add(BUSY);
  rows = row ? dependentRows(row) : [];
  rows.forEach((r) => r.classList.add(REMOVING));
  wrapText(inner);
  const bar = document.querySelector('.bs-co-bar');
  if (bar) wrapText(bar);
  clearTimeout(timer);
  timer = setTimeout(endCartSkeleton, TIMEOUT_MS);
}

/**
 * Konec kostry. Po výměně `.cart-inner` už obaly ani sbalené řádky v DOM
 * nejsou (nový markup); kde obsah zůstal (chyba), vrátí se do původní podoby.
 */
export function endCartSkeleton() {
  clearTimeout(timer);
  timer = 0;
  if (!cartSkeletonActive()) return;
  document.documentElement.classList.remove(BUSY);
  for (const span of document.querySelectorAll('.' + WRAP)) {
    const parent = span.parentNode;
    while (span.firstChild) parent.insertBefore(span.firstChild, span);
    span.remove();
  }
  rows.forEach((r) => r.classList.remove(REMOVING));
  rows = [];
}
